import React, { useState, useEffect, useRef } from 'react';

export default function Header() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const headerRef = useRef(null);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const closeNavOnClick = (event) => {
    if (headerRef.current && !headerRef.current.contains(event.target)) {
      setIsNavOpen(false);
    }
  };

  // Add scroll detection for header styling
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Add event listener to close the navigation menu when clicking outside the header
  useEffect(() => {
    document.addEventListener('click', closeNavOnClick);

    return () => {
      document.removeEventListener('click', closeNavOnClick);
    };
  }, []);

  return (
    <header ref={headerRef}>
      <div className={`header horizontal-flex-container align-center ${isScrolled ? 'scrolled' : ''}`}>
        <div className='header-content-container'>
          <a href='#hero' className='header-logo-link'>
            <div className='header-logo-container horizontal-flex-container align-center h-inherit'>
              <div className='header-logo-wrapper'>
                <img className='header-logo-img br-20' src='/img/profile-picture.png' alt='Profile'/>
                <div className='header-logo-ring'></div>
              </div>
              <div className='header-logo-text'>
                <span className='header-logo-name'>Andrew Dawson</span>
                <span className='header-logo-subtitle'>Software Engineer</span>
              </div>
            </div>
          </a>
          <nav className={`header-nav ${isNavOpen ? 'open' : ''}`}>
            <button 
              className='hamburger' 
              onClick={toggleNav}
              aria-label='Toggle navigation menu'
              aria-expanded={isNavOpen}
            >
              <span className='bar'></span>
              <span className='bar'></span>
              <span className='bar'></span>
            </button>
            <ul className={isNavOpen ? 'open' : ''}>
              <li><a href='#hero' onClick={toggleNav} className='nav-link'>Home</a></li>
              <li><a href='#experience' onClick={toggleNav} className='nav-link'>Experience</a></li>
              <li><a href='#projects' onClick={toggleNav} className='nav-link'>Projects</a></li>
              <li><a href='#contact' onClick={toggleNav} className='nav-link'>Contact</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}
